<template>
    <RouterView v-slot="{ Component, route }">
        <component :is="Component" :key="route.name" />
    </RouterView>
    <UnauthorizedAccessDialog />
    <VueQueryDevtools button-position="bottom-left" />
    <Toast position="top-right" :close-button-props="{ autofocus: false }" />
    <Toast position="bottom-right" group="signalr" :close-button-props="{ autofocus: false }" />
</template>

<script setup lang="ts">
    import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
    import { Toast } from 'primevue';
</script>
